export default "__VITE_ASSET__Ds8Mo8Hi__"